var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGlobeStand = function SvgIconGlobeStand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.816 2.816a1 1 0 0 0-1.414-1.414A10.745 10.745 0 0 0 11 19.698v1.427H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-1.427a10.75 10.75 0 0 0 6.597-3.1 1 1 0 1 0-1.414-1.414A8.745 8.745 0 1 1 5.816 2.816"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14M7 9a5 5 0 1 1 10 0A5 5 0 0 1 7 9",
    clipRule: "evenodd"
  }))));
};
export default SvgIconGlobeStand;